// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__trZzD","footer":"ModalUpdate_footer__1BcaM"};